<template>
    <div v-show="visible">
        <el-dialog title="修改假期" :close-on-click-modal="false" :visible.sync="visible" 
            v-loading="loading"
            element-loading-background = "rgba(255, 255,255,0.7)"
            element-loading-text = "保存中..."
            :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                <el-form-item   prop="vacationName" label="假期名称：">
                    <el-input v-model="form.vacationName" maxlength="50" style="width:280px;"></el-input>
                </el-form-item>
                <el-form-item prop="" label="适用范围：">
                    <el-button @click="findUser()">{{setVal.checkUsersLabel}}</el-button>
                </el-form-item>
                <el-form-item   prop="leaveDurationType" label="请假时长核算：" >
                    <el-select v-model="form.leaveDurationType" placeholder="请选择" style="width:280px;" clearable>
                        <el-option
                            v-for="item in leaveDurationTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <div v-if="form.leaveDurationType == 2" class="leaveDurationTypeTip">请假时段中不包含员工的休息日，例如未排班的双休日、法定节假日</div>
                    <div v-if="form.leaveDurationType == 1" class="leaveDurationTypeTip">请假时段中包含的休息日，也会计入请假天数</div>
                </el-form-item>
                <el-form-item  prop="" label="设置员工假期余额：" >
                    <el-switch @change="setRules"
                        v-model="form.setSwitch"
                        active-color="#13ce66">
                    </el-switch>
                </el-form-item>
                <div v-if="form.setSwitch">
                    <el-form-item   prop="grantMethod" label="余额发放方式：" >
                        <el-select v-model="form.grantMethod" placeholder="请选择" style="width:280px;" clearable>
                            <el-option
                                v-for="item in grantMethods"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item   prop="grantDate" label="发放日期：" >
                        <el-select v-model="form.grantDate" placeholder="请选择" style="width:280px;" clearable>
                            <el-option
                                v-for="item in grantDates"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  prop="quotaConfigureRules" label="额度配置规则：" >
                        <el-select v-model="form.quotaConfigureRules" placeholder="请选择" style="width:280px;" clearable>
                            <el-option
                                v-for="item in quotaConfigureRuless"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item   prop="quotaDays" label="额度：">
                        每人每年发放<el-input v-model="form.quotaDays" max="100"  min="1" type="number" oninput ="value=value.replace(/[^\d]/g,'');" style="width:80px;"></el-input>&nbsp;天
                    </el-form-item>
                    <el-form-item  prop="validDate" label="有效期：" >
                        <el-select v-model="form.validDate" placeholder="请选择" style="width:280px;">
                            <el-option
                                v-for="item in validDates"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                loading:false,
                visible: false,
                transferVisible:false,
                setVal:{
                    checkUsersLabel:"所有人员",
                },
                form:{
                    id:"",
                    deptId:"",
                    vacationName:"",
                    checkUsers:[],
                    leaveDurationType:1,
                    setSwitch:false,
                    grantMethod:1,
                    grantDate:11,
                    quotaConfigureRules:1,
                    quotaDays:5,
                    validDate:1,
                },
                leaveDurationTypes:[{
                    value: 1,
                    label: '按自然日计算请假时长'
                }, {
                    value: 2,
                    label: '按工作日计算请假时长'
                }],
                grantMethods:[{
                    value: 1,
                    label: '每年自动发放1次'
                }],
                grantDates:[{
                    value: 11,
                    label: '每年1月1日'
                }],
                quotaConfigureRuless:[{
                    value: 1,
                    label: '固定额度'
                }],
                validDates:[{
                    value: 1,
                    label: '自发放日起1周年'
                }],
                rules: {
                    vacationName: [
                        { required: true, message: '假期名称不可为空', trigger: 'blur' }
                    ],
                    leaveDurationType: [
                        { required: true, message: '请选择请假时长核算', trigger: 'blur' }
                    ],
                    leaveDurationType: [
                        { required: true, message: '请选择请假时长核算', trigger: 'blur' }
                    ],
                },
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }

                let url=this.staffLeaveRulesListUserUrl;
                let reqData={
                    'leaveRulesId':data.id
                };
                this.apiPost(url, reqData).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status === 200){
                       
                        if(res.data == ""){
                            this.setVal.checkUsersLabel = "所有人员";
                            this.form.checkUsers = [];
                        }else{
                            this.form.checkUsers=res.data.split(',');
                            this.setVal.checkUsersLabel=res.data.split(',').length+"个人";
                        }
                        // 值初始化
                        this.form.id=data.id;
                        this.form.deptId=data.deptId;
                        this.form.vacationName=data.vacationName;
                        this.form.leaveDurationType=data.leaveDurationType;
                        this.form.setSwitch=data.setSwitch;
                        this.form.grantMethod=data.grantMethod;
                        this.form.grantDate=data.grantDate;
                        this.form.quotaConfigureRules=data.quotaConfigureRules;
                        this.form.quotaDays=data.quotaDays;
                        this.form.validDate=data.validDate;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                }, (err) => {
                    console.log(err);
                });
                
                
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            setRules(){
                 // 动态添加rules规则
                 if(this.form.setSwitch){
                    // 余额发放方式
                    this.rules["grantMethod"]=[];
                    this.rules["grantMethod"].push({ required: true, message: '请选择余额发放方式', trigger: 'blur' });
                    // 发放日期
                    this.rules["grantDate"]=[];
                    this.rules["grantDate"].push({ required: true, message: '请选择发放日期', trigger: 'blur' });
                    // 额度配置规则
                    this.rules["quotaConfigureRules"]=[];
                    this.rules["quotaConfigureRules"].push({ required: true, message: '请选择余额发放方式', trigger: 'blur' });
                    // 额度
                    this.rules["quotaDays"]=[];
                    this.rules["quotaDays"].push({ required: true, message: '额度不可为空', trigger: 'blur' });
                 }else{
                     delete this.rules["grantMethod"];
                     delete this.rules["grantDate"];
                     delete this.rules["quotaConfigureRules"];
                     delete this.rules["quotaDays"];
                 }
            },
            save(){

                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.staffLeaveRulesUpdateUrl;
                        
                        let data = {};
                        if(this.form.setSwitch){
                            if(this.form.quotaDays <=0){
                                 this.$commonFn.showTip("额度不能小于或者等于0",3);
                                 return;
                            }
                            data = {
                                id:this.form.id,
                                deptId:this.form.deptId,
                                vacationName:this.form.vacationName,
                                teacherUser:(this.form.checkUsers.length == 0?"":this.form.checkUsers.join(',')),
                                leaveDurationType:this.form.leaveDurationType,
                                setSwitch:this.form.setSwitch,
                                grantMethod:this.form.grantMethod,
                                grantDate:this.form.grantDate,
                                quotaConfigureRules:this.form.quotaConfigureRules,
                                quotaDays:this.form.quotaDays,
                                validDate:this.form.validDate
                            };
                        }else{
                            data = {
                                id:this.form.id,
                                deptId:this.form.deptId,
                                vacationName:this.form.vacationName,
                                teacherUser:(this.form.checkUsers.length == 0?"":this.form.checkUsers.join(',')),
                                leaveDurationType:this.form.leaveDurationType,
                                setSwitch:this.form.setSwitch
                            };
                        }
                        // console.log(JSON.stringify(data));
                        // return;
                        this.loading=true;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            },
            // 绑定人员
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.form.checkUsers.length > 0){
                        this.$refs['userTransfer'].init(2,this.form.checkUsers,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(keyArr){
                // console.log(JSON.stringify(keyArr));
                if(keyArr.length == 0){
                    this.form.checkUsers=keyArr;
                    this.setVal.checkUsersLabel="所有人员";
                }else{
                    this.form.checkUsers=keyArr;
                    this.setVal.checkUsersLabel=keyArr.length+"个人";
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
.leaveDurationTypeTip{
    line-height: 28px;
    color: #cccccc;
    font-size: 12px;
    margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/page/vacation/leaveRules/Update.vue